import { Address } from '@client/core/address/types';

/**
 * Builds a full address from the parts of a location.
 * This works for a comp or a project.
 */
export function buildFullAddress(address: Address): string {
  const streetAddress = `${address.address1 ?? ''} ${address.address2 ?? ''}`.trim();
  const city = (address.city ?? '').trim();
  const region = address.region && address.region !== 'other' ? address.region : '';
  const postalCode = (address.postalCode ?? '').trim();
  const addressParts = [streetAddress, city, [region, postalCode].filter(Boolean).join(' ')].filter(Boolean);

  return addressParts.join(', ');
}
